"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";

/** Availability only: backup validation and ownership checks remain authoritative. */
export function useSeedCreation() {
  const $ = _c(2);
  const [enabled, setEnabled] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const controller = new AbortController();
      fetch("/api/features/seed-recovery", {
        signal: controller.signal,
        cache: "no-store"
      }).then(async response => {
        if (!response.ok) {
          return;
        }
        const body = await response.json();
        if (!controller.signal.aborted) {
          setEnabled(body.creationEnabled === true);
        }
      }).catch(_temp);
      return () => controller.abort();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return enabled;
}
function _temp() {}